module.exports = __webpack_public_path__ + "img/delays-and-response-times.aa57eda1.jpg";